export { WithPlace } from './WithPlace'
export { WithAuthentication as WithAnonymousAuthentication } from './WithAnonymousAuthentication'
